import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppErrorBoundary from './AppErrorBoundary';
import RootApplication from './RootApplication';
import { BasketProvider } from './basket';
import { LearningCourseBasketProvider } from './learning-course-basket';
import { importStorefrontBasketHandoff } from './storefront-basket-handoff';
import './lms-start-course-routing';
import './styles.css';
import './reliability.css';
import './learner-details.css';
import './mobile-responsive.css';
import './dark-select-fix.css';
import './digital-consent.css';

function enableReliableInternalNavigation() {
  document.addEventListener('click', (event: MouseEvent) => {
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const anchor = target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (anchor.target && anchor.target !== '_self') return;
    if (anchor.hasAttribute('download')) return;

    const destination = new URL(anchor.href, window.location.href);
    if (destination.origin !== window.location.origin) return;

    const sameDocument =
      destination.pathname === window.location.pathname
      && destination.search === window.location.search;

    if (sameDocument && destination.hash) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination.href);
  }, true);
}

enableReliableInternalNavigation();

// The central Sousa Murray storefront can hand a validated mixed course basket
// into eLearning. Import it before the basket providers read localStorage so the
// first rendered checkout state already matches what the customer selected.
importStorefrontBasketHandoff();

const root = document.getElementById('app');
if (!root) throw new Error('Application root not found.');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <BasketProvider>
          <LearningCourseBasketProvider>
            <RootApplication />
          </LearningCourseBasketProvider>
        </BasketProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>,
);
